import {Injectable} from '@angular/core';
import {ProductKind} from '../models/product-kind';
import {BaseService} from '../base.service';
import {HttpService} from '../http.service';
import {environment} from '../../environments/environment';

@Injectable()
export class ProductKindService extends BaseService {
    private api: string;

    /**
    * ProductKindService constructor
    *
    * @param {HttpService} http
    */
    constructor(private http: HttpService)
    {
        super();
        this.api = environment.api_url;
    }

    public getProductKinds()
    {
        return this.http.get(this.api + 'product-kinds')
            .map(response => response.json() as ProductKind[])
    }
}



// WEBPACK FOOTER //
// ./src/app/services/product-kind.service.ts